import { render, staticRenderFns } from "./CollectionCover.vue?vue&type=template&id=6668e758&scoped=true&"
import script from "./CollectionCover.vue?vue&type=script&lang=js&"
export * from "./CollectionCover.vue?vue&type=script&lang=js&"
import style0 from "./CollectionCover.vue?vue&type=style&index=0&id=6668e758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6668e758",
  null
  
)

export default component.exports